import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { LeadLinkColumnConfig } from "../model";

interface DashboardProPageConfigState {
  columns: LeadLinkColumnConfig[];
  editColumn: (id: string) => void;
}

const DEFAULT_COLUMNS: LeadLinkColumnConfig[] = [
  { id: "name", title: "Название", visible: true, locked: true },
  { id: "description", title: "Описание", visible: true, locked: true },
  { id: "leadsCount", title: "Лидов", visible: true, locked: true },
  { id: "costs", title: "Траты", visible: true, locked: true },
  { id: "totalProfit", title: "Заработок", visible: true, locked: true },
  { id: "depositsCount", title: "Кол-во Депов", visible: true, locked: false },
  { id: "createdAt", title: "Создана", visible: true, locked: false },
  { id: "CR", title: "CR", visible: true, locked: false },
  { id: "AD", title: "AD", visible: true, locked: false },
  { id: "AP", title: "AP", visible: true, locked: false },
  { id: "CPC", title: "CPC", visible: true, locked: false },
  { id: "CPL", title: "CPL", visible: true, locked: false },
  { id: "CPS", title: "CPS", visible: true, locked: false },
  { id: "EPC", title: "EPC", visible: true, locked: false },
  { id: "EPL", title: "EPL", visible: true, locked: false },
  { id: "EPS", title: "EPS", visible: true, locked: false },
  { id: "type", title: "Тип", visible: true, locked: true },
  { id: "url", title: "Ссылка (действия)", visible: true, locked: false },
];

export const useDashboardProPageConfigStore = create(
  persist<DashboardProPageConfigState>(
    (set, get) => ({
      columns: DEFAULT_COLUMNS,

      editColumn: (id: string) => {
        const columns = get().columns.map((col) =>
          col.id === id && !col.locked
            ? { ...col, visible: !col.visible }
            : col,
        );
        set({ columns });
      },
    }),
    {
      name: "dashboard-pro-page-config",
    },
  ),
);
